import { AxiosResponse } from "axios";
import api from "./api";

export interface IEventoCompartilhamento {
  id: number;
  email: string;
  exibirNomesAtletas: boolean;
  permitirUploadFotos: boolean;
  ativo: boolean;
  convidadoEm: string;
  revogadoEm?: string | null;
  ultimoAcessoEm?: string | null;
  userId?: string | null;
  user?: { id: string; nome: string } | null;
}

function ensureSuccess<T>(response: AxiosResponse<T>): T {
  if (response.status >= 400) {
    const data = response.data as { message?: string };
    throw new Error(data?.message || "Falha na comunicação com o servidor");
  }
  return response.data;
}

function normalizeError(error: unknown) {
  const err = error as {
    response?: { data?: { message?: string } };
    message?: string;
  };
  return new Error(
    err?.response?.data?.message ||
      err?.message ||
      "Falha na comunicação com o servidor"
  );
}

export async function listarCompartilhamentosEvento(
  eventoId: number
): Promise<IEventoCompartilhamento[]> {
  try {
    const response = await api.get<IEventoCompartilhamento[]>(
      `/evento/${eventoId}/compartilhamentos`
    );
    const data = ensureSuccess(response);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function convidarCompartilhamentoEvento(
  eventoId: number,
  payload: {
    email: string;
    exibirNomesAtletas: boolean;
    permitirUploadFotos?: boolean;
  }
): Promise<IEventoCompartilhamento> {
  try {
    const response = await api.post<IEventoCompartilhamento>(
      `/evento/${eventoId}/compartilhamentos`,
      payload
    );
    return ensureSuccess(response);
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function revogarCompartilhamentoEvento(
  eventoId: number,
  compartilhamentoId: number
): Promise<void> {
  try {
    await api.delete(
      `/evento/${eventoId}/compartilhamentos/${compartilhamentoId}`
    );
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function atualizarCompartilhamentoEvento(
  eventoId: number,
  compartilhamentoId: number,
  patch: { exibirNomesAtletas?: boolean; permitirUploadFotos?: boolean }
): Promise<IEventoCompartilhamento> {
  try {
    const response = await api.patch<IEventoCompartilhamento>(
      `/evento/${eventoId}/compartilhamentos/${compartilhamentoId}`,
      patch
    );
    return ensureSuccess(response);
  } catch (error) {
    throw normalizeError(error);
  }
}
